import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import {
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import { Card, CardText, Checkbox, Divider } from 'react-md';

import LangSwitch from './LangSwitch';
import ErrorDisplay from '../ErrorDisplay';
import LoaderButton from '../LoaderButton';
import FieldGroup from '../FieldGroup';

import { login, completeNewPasswordChallenge } from '../../libs/awsLib';

import './Login.css';

function parseInvalidPasswordException(e) {
  if (e.message.indexOf('Password not long') !== -1) return 'InvalidPasswordExceptionLong';
  if (e.message.indexOf('Password must have upper') !== -1) return 'InvalidPasswordExceptionUpper';
  if (e.message.indexOf('Password must have lower') !== -1) return 'InvalidPasswordExceptionLower';
  if (e.message.indexOf('Password must have numer') !== -1) return 'InvalidPasswordExceptionNumeric';
  if (e.message.indexOf('Password must have symbol') !== -1) return 'InvalidPasswordExceptionSymbol';
  return e.message;
}

function parseInvalidParameterException(e) {
  if (e.message.indexOf('Value at \'password\' failed') !== -1) return 'InvalidParameterExceptionPassword';
  return e.message;
}

export default injectIntl(class Login extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    userHasAuthenticated: PropTypes.func.isRequired,
    handleChangeLocale: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: localStorage.lastUserLogin || '',
      password: '',
      confirmPassword: '',
      error: undefined,
      user: undefined,
      newPasswordRequired: false,
    };
  }

  // ----EMAIL-FORM

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  validateNewPasswordRequiredForm() {
    return (
      this.state.password.length > 0 &&
     this.state.password === this.state.confirmPassword
    );
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.type === 'checkbox' ? event.target.checked : event.target.value.trim(),
      error: undefined,
    });
  };

  handleNewPasswordRequiredSubmit = async (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });
    try {
      await completeNewPasswordChallenge(this.state.user, this.state.password);
      this.props.userHasAuthenticated(true);
    } catch (e) {
      this.setState({ isLoading: false });
      if (e.name === 'InvalidPasswordException') {
        this.setState({ error: parseInvalidPasswordException(e) });
      } else if (e.name === 'InvalidParameterException') {
        this.setState({ error: parseInvalidParameterException(e) });
      } else if (e.name === 'NetworkingError') {
        this.setState({ error: e.name });
      } else {
        console.log(e);
        alert(e.message);
      }
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });
    console.log('this.state.remember-me : ', this.state['remember-me']);
    if (this.state['remember-me']) localStorage.lastUserLogin = this.state.email;
    else localStorage.removeItem('lastUserLogin');

    try {
      await login(this.state.email, this.state.password);
      this.props.userHasAuthenticated(true);
    } catch (e) {
      this.setState({ isLoading: false });
      if (e.name === 'UserNotFoundException' || e.name === 'NotAuthorizedException' || e.name === 'NetworkingError') {
        this.setState({ error: e.name });
      } else if (e.name === 'newPasswordRequired') {
        console.log('"newPasswordRequired"');

        this.setState({ newPasswordRequired: true, user: e.user });
      } else {
        console.log(e);
        alert(e.message);
      }
    }
  };

  renderNewPasswordRequiredForm() {
    const { intl } = this.props;
    const { error } = this.state;
    return (
      <div>
        <CardText className="welcome">
          <FormattedMessage id="login.definePassword" tagName="h3" />
        </CardText>
        <Divider />
        <CardText>
          <div className="passwordInstructions">
            <FormattedMessage id="login.instructions.title" />
            <ul>
              <li>8 <FormattedMessage id="login.instructions.characters" /></li>
              <li>1 <FormattedMessage id="login.instructions.uppercase" /></li>
              <li>1 <FormattedMessage id="login.instructions.number" /></li>
              <li>1 <FormattedMessage id="login.instructions.symbol" />{' (# @ & ! ? $ { } / \\  * - … )'}</li>
            </ul>
          </div>
          <form onSubmit={this.handleNewPasswordRequiredSubmit}>
            <ErrorDisplay error={error} />
            <FormGroup controlId="password" bsSize="large">
              <ControlLabel><FormattedMessage id="signup.passwordPlaceholder" /></ControlLabel>
              <FormControl
                value={this.state.password}
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>
            <FormGroup controlId="confirmPassword" bsSize="large" validationState={this.state.confirmPassword !== this.state.password ? 'error' : null}>
              <ControlLabel><FormattedMessage id="signup.confirmPasswordPlaceholder" /></ControlLabel>
              <FormControl
                value={this.state.confirmPassword}
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>
            <LoaderButton
              flat
              swapTheming
              primary
              className="md-full-width big last"
              disabled={!this.validateNewPasswordRequiredForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text={intl.formatMessage({ id: 'login.definePasswordButton' })}
              loadingText={intl.formatMessage({ id: 'login.definePasswordButtonBussy' })}
            />
          </form>
        </CardText>
      </div>
    );
  }


  renderLoginForm() {
    const { intl } = this.props;
    const { error } = this.state;
    return (
      <div>
        <CardText className="welcome">
          <FormattedMessage id="login.welcome1" tagName="h3" />
          <FormattedMessage id="login.welcome2" tagName="h4" />
        </CardText>
        <Divider />
        <CardText>
          <form onSubmit={this.handleSubmit}>
            <ErrorDisplay error={error} />

            <FieldGroup
              bsSize="large"
              id="email"
              autoFocus
              placeholder={intl.formatMessage({ id: 'login.emailPlaceholder' })}
              type="email"
              value={this.state.email}
              onChange={this.handleChange}
              label={intl.formatMessage({ id: 'login.email' })}
              tabIndex={1}
            />


            <FieldGroup
              id="password"
              label={[
                <FormattedMessage key="left" id="login.password" />,
                <Link key="right" className="float-right" to="/forgottenPassword">
                  <FormattedMessage
                    id="login.forgottenPassword"
                  />
                </Link>,
                  ]}
              labelClassName="md-full-width"
              bsSize="large"
              placeholder={intl.formatMessage({ id: 'login.passwordPlaceholder' })}
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
              tabIndex={2}
            />
            <Checkbox
              className="rememberMe"
              id="remember-me"
              name="rememberMe"
              label={intl.formatMessage({ id: 'login.rememberMe' })}
              value="rememberMe"
              onChange={(v, e) => this.handleChange(e)}
              tabIndex={3}
            />

            <LoaderButton
              flat
              swapTheming
              primary
              className="md-full-width big last"
              disabled={!this.validateForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text={intl.formatMessage({ id: 'login.connect' })}
              loadingText={intl.formatMessage({ id: 'login.connectBussy' })}
            />
          </form>
        </CardText>
      </div>
    );
  }

  render() {
    const { handleChangeLocale } = this.props;
    return (
      <div>
        <LangSwitch handleChangeLocale={handleChangeLocale} />
        <div className="md-block-centered login">
          <div className="lander">
            <div className="logo md-block-centered" />
            <Card>
              {this.state.newPasswordRequired
                ? this.renderNewPasswordRequiredForm()
                : this.renderLoginForm()}
            </Card>
            <div className="contact">
              <Link className="secondary" to="/privacy-policy">
                Privacy Policy
              </Link>
              <a href="mailto:brake@vias.be" className="secondary">Contact</a>
              <Link className="secondary" to="/faq">
                FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/Login/Login.js